import React, { useEffect, useState } from 'react';

import './administration.module.scss';

import { EventTab, OntologyTab, UserRightsTab, UserTab } from 'src/app/pages/Administration/tabs';
import { statusHelper, storageHelper } from 'src/app/helpers';
import { errorLocals } from 'src/locals';
import { axiosExport } from 'src/app/utils';
import { useDispatch, useSelector } from 'react-redux';
import { exportFile } from 'src/app/services/export.service';
import { reduxRootTypes } from 'src/types';
import { checkPermissionList } from 'src/app/helpers/permissions.helper';
import { PermissionEnum } from 'src/enums/permission.enum';
import SettingTab from './tabs/SettingTab/Setting';
import LogsTab from './tabs/LogsTab/Logs';
import EmailSettingsTab from './tabs/EmailSettingsTab/EmailSettings';

import { useTranslation } from 'react-i18next';
import { UserProvider } from 'src/app/context/UserContext';

import Tabs from 'antd/es/tabs';
import { settingService } from 'src/app/services';
import { contentsActions } from 'src/app/redux/actions';

const Ontology = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { TabPane } = Tabs;

  const [activeKey, setActiveKey] = useState<string>('1');
  const { eventId } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  const exportProps = async () => {
    try {
      axiosExport.setEventId(eventId);
      storageHelper.setValueWithKey('eventId', eventId.toString());

      const excelExport = await exportFile({ eventId });

      // const data = Uint8Array.from(excelExport.data);
      const content = new Blob([excelExport.data]);
      const encodedUri = window.URL.createObjectURL(content);
      const link = document.createElement('a');
      link.href = encodedUri;
      link.download = 'excelExport.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // link.setAttribute('href', encodedUri);
      // link.setAttribute('download', 'excelExport.xslx');
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(`Failed to load players from import ${error.response.data.message}`, 5);
      }
    }
  };

  const getSettingsData = async () => {
    try {
      const settingListData = await settingService.lookupSetting({
        blockSpinner: true,
      });

      dispatch(contentsActions.settingList(settingListData.data.rows));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSettingsData();
  }, [eventId]);

  return (
    <>
      <Tabs
        className="tabs"
        defaultActiveKey="1"
        id="ontologyTabs"
        onChange={(key: string) => setActiveKey(key)}
        // tabBarExtraContent={uploadOperation}
      >
        <TabPane
          tab={t('administration.tabs.ontologies')}
          key="1"
          disabled={checkPermissionList(PermissionEnum.OntologiesRead)}
        >
          <OntologyTab />
        </TabPane>
        <TabPane tab={t('general.event')} key="2" disabled={checkPermissionList(PermissionEnum.EventRead)}>
          <EventTab activeKey={activeKey} defaultKey={'2'} />
        </TabPane>
        <TabPane
          tab={t('administration.tabs.userRights')}
          key="3"
          disabled={checkPermissionList(PermissionEnum.UserRightsRead)}
        >
          <UserRightsTab activeKey={activeKey} defaultKey={'3'} />
        </TabPane>
        <TabPane tab={t('administration.tabs.users')} key="4" disabled={checkPermissionList(PermissionEnum.UserRead)}>
          <UserTab activeKey={activeKey} defaultKey={'4'} />
        </TabPane>

        <TabPane
          tab={t('administration.tabs.settings')}
          key="5"
          disabled={checkPermissionList(PermissionEnum.SettingRead)}
        >
          <UserProvider>
            <SettingTab activeKey={activeKey} defaultKey={'5'} />
          </UserProvider>
        </TabPane>
        <TabPane tab={t('administration.tabs.logs')} key="6">
          <LogsTab activeKey={activeKey} defaultKey={'6'} />
        </TabPane>
        <TabPane tab={t('administration.tabs.mailSettings')} key="7">
          <EmailSettingsTab activeKey={activeKey} defaultKey={'7'} />
        </TabPane>
      </Tabs>
    </>
  );
};

export default Ontology;
